import React, {Component} from "react";
import {Button, Modal} from "semantic-ui-react";
const moment = require('moment');


export default class WorkHistoryModal extends Component {


    render() {
        const {doctorWorkHistory,DocData} = this.props
        return (
            <Modal
                open={true}
                onClose={this.props.hideWorkHistoryModal}
                aria-labelledby="ModalHeader"
                backdrop={false}
                className="show"
                dialogClassName="modal-90w"
                centered
            >
                <Modal.Header>
                    <span >  Status:</span> {DocData.status===true?'Active' :'DeActive'}
                    &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; <span> Home Location:</span> {DocData.homeLocation || 'Not Set'}

                </Modal.Header>

                <Modal.Content>
                    <div className="ui card">
                        <div className="content">
                            <div className="table-responsive">
                                <table className="table table-striped table-hover my-0">
                                    <thead>
                                    <tr>
                                        <th className={`FreezeTable-first-child `} >
                                            <div>
                                                Practice
                                            </div>
                                        </th>
                                        <th className={`FreezeTable-first-child `} >
                                            <div>
                                                Days Worked
                                            </div>
                                        </th>
                                        <th className={`FreezeTable-first-child `}>
                                            <div>
                                                First Work Date
                                            </div>
                                        </th>
                                        <th className={`FreezeTable-first-child `} >
                                            <div>
                                                Last Work Date
                                            </div>
                                        </th>
                                        <th className={`FreezeTable-first-child `} >
                                            <div>
                                                Next Work Date
                                            </div>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    {
                                        doctorWorkHistory&&doctorWorkHistory.length <= 0?"No Schedule History": (doctorWorkHistory&&doctorWorkHistory.map(data=>{
                                            return <tr>
                                                <td> {data.practice}</td>
                                                <td> {data.days}</td>
                                                <td> {moment(data.firstWorkDay).format('YYYY-MM-DD')}</td>
                                                <td> {data.lastWorkDay ? moment(data.lastWorkDay).format('YYYY-MM-DD'):'No Schedule'}</td><
                                                td> {data.nextWorkDay ? moment(data.nextWorkDay).format('YYYY-MM-DD'):'No Schedule'}</td></tr>
                                        }))

                                    }

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button secondary onClick={this.props.hideWorkHistoryModal}>
                        Close
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}
